import React from "react";
import PropTypes from "prop-types";
import {
    Container,
    Button,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    IconButton
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import SearchBar from "material-ui-search-bar";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { AppContext, WarningModal } from "components";
import { ProductController } from "controllers";
import { BaseComponent } from "shared/components"

import styles from "./StylistAssignContainer.module.scss";

//redux
import { connect } from 'react-redux';

const mapStateToProps = (state, ownProps) => {
    return { ...ownProps, country: state.countries.value }
};

const { map } = require("p-iteration");

class StylistAssignContainer extends BaseComponent {

    constructor(props) {
        super(props);

        this.state = {
            barcode: "",
            users: [],
            stylist: null,
            customerSelected: null,
            filteredUsers: [],
            filteredCustomers: [],
            allProducts: [],
            barcodes: [],
            loading: false,
            key: "",
            custKey: "",
            isModalVisible: false,
            isChangeStylistModalVisible: false
        };
    }

    componentDidMount = async () => {
        //await this.reload();
        toast.configure({
            autoClose: 2000,
            draggable: false
            //etc you get the idea
        });
        document.addEventListener("keypress", function (e) {
            if (e.target.tagName !== "INPUT") {
                var input = document.querySelector("#barcode");
                input.focus();
                input.value = e.key;
                e.preventDefault();
            }
        });
    };

    reload = async () => {
        this.setState({ loading: true });
        this.context.showLoading();
        let users = await ProductController.getUsers();

        // user box items
        users &&
            users.length !== 0 &&
            (await map(users, async user => {
                const boxes = user.boxes;
                let userBarcodes = [];
                boxes &&
                    boxes.length !== 0 &&
                    (await map(boxes, async box => {
                        let items = box.items;
                        items &&
                            items.length !== 0 &&
                            (await map(items, async item => {
                                userBarcodes.push(item.barcode);
                            }));
                    }));
                user.barcodes = userBarcodes;
            }));

        let allProducts = await ProductController.getBarcodes();
        this.setState({ users, allProducts });
        this.context.hideLoading();
        this.setState({ loading: false });
    };

    search = async text => {
        this.setState({ key: text, stylist: null });
        const { country } = this.props;
        let newList = [];
        if (text !== "" && text.length > 1) {
            this.context.showLoading();
            newList = await ProductController.getStylistsByQuery(text, 150, country);
            this.context.hideLoading();
            this.setState({ loading: false });
            newList &&
                newList.length !== 0 &&
                (await map(newList, async user => {
                    const boxes = user.boxes;
                    let userBarcodes = [];
                    boxes &&
                        boxes.length !== 0 &&
                        (await map(boxes, async box => {
                            let items = box.items;
                            items &&
                                items.length !== 0 &&
                                (await map(items, async item => {
                                    userBarcodes.push(item.barcode);
                                }));
                        }));
                    user.barcodes = userBarcodes;
                }));
        } else {
            newList = [];
        }
        this.setState({
            filteredUsers: newList
        });
    };
    searchCustomer = async text => {
        this.setState({ custKey: text, customerSelected: null });
        let { stylist } = this.state;
        const { country } = this.props;
        if (!stylist) {
            toast.error("Please select a stylist name first", {
                position: toast.POSITION.TOP_LEFT
            });

            await this.setState({ customerSelected: null, custKey: "" });
            return;
        }
        let newList = [];
        if (text !== "" && text.length > 1) {
            this.context.showLoading();
            newList = await ProductController.getUsersByQuery(text, 20, country);
            newList = newList.filter(user => {
                return user.user_type !== 'stylist';
            });
            this.context.hideLoading();
            this.setState({ loading: false });
            newList &&
                newList.length !== 0 &&
                (await map(newList, async user => {
                    const boxes = user.boxes;
                    let userBarcodes = [];
                    boxes &&
                        boxes.length !== 0 &&
                        (await map(boxes, async box => {
                            let items = box.items;
                            items &&
                                items.length !== 0 &&
                                (await map(items, async item => {
                                    userBarcodes.push(item.barcode);
                                }));
                        }));
                    user.barcodes = userBarcodes;
                }));
        } else {
            newList = [];
        }
        this.setState({
            filteredCustomers: newList
        });
    };

    handleChange = type => e => {
        this.setState({
            [type]: e.target.value
        });
    };

    selectUser = async user => {
        this.setState({
            stylist: user,
            key: user.first_name + " " + user.last_name,
            filteredUsers: []
        });
    };

    selectCustomer = async user => {
        let { barcodes, stylist } = this.state;
        this.setState({ barcode: user });

        const exists = barcodes.some((barcode) => barcode.id === user.id);

        if (!stylist) {
            toast.error("Please select a stylist name first", {
                position: toast.POSITION.TOP_LEFT
            });

            await this.setState({ customerSelected: null, custKey: "" });
            return;
        }

        if (user.current_stylist === stylist.id) {
            toast.error("This user previously assigned to this stylist", {
                position: toast.POSITION.TOP_LEFT
            });

            await this.setState({ customerSelected: null, custKey: "" });
            return;
        }

        this.setState({
            customerSelected: user,
            custKey: "",
            filteredCustomers: []
        });

        if (exists) {
            toast.warn("This User is already added to the current list", {
                position: toast.POSITION.TOP_LEFT
            });

            return;
        }
        if (user.current_stylist && user.current_stylist.length > 0) {
            await this.setState({ customerSelected: null, custKey: "", isChangeStylistModalVisible: true });
            return;
        }
        barcodes.push(user);
    };

    removeBarCode = code => {
        let { barcodes } = this.state;
        barcodes = barcodes.filter(product => {
            return product.id !== code.id;
        });
        this.setState({ barcodes });
    };

    addClicked = async () => {
        const { stylist, barcodes } = this.state;

        try {
            if (!stylist) { throw new Error('Please select stylist'); }
            if (barcodes.length === 0) { throw new Error('Please select customer'); }
        } catch (error) {
            toast.error(error.message, {
                position: toast.POSITION.TOP_LEFT
            });

            return;
        }

        this.setState({ isModalVisible: true });
    };

    handleModalDisagree = () => {
        this.setState({ isModalVisible: false });
    }

    handleModalAgree = async () => {
        this.setState({
            loading: true,
            isModalVisible: false
        });

        const { barcodes, stylist } = this.state;

        this.context.showLoading();

        ProductController.addUsersToStylist(stylist, barcodes)
            .then(() => {
                this.setState({
                    barcode: "",
                    stylist: null,
                    filteredUsers: [],
                    barcodes: [],
                    key: ""
                });

                toast.success("Success!", {
                    position: toast.POSITION.TOP_LEFT
                });
            })
            .catch((error) => {
                toast.error(error.message, {
                    position: toast.POSITION.TOP_LEFT
                });
            })
            .finally(() => {
                this.context.hideLoading();
                this.setState({ loading: false });
            });
    };

    handleChangeStylistModalDisagree = () => {
        this.setState({
            isChangeStylistModalVisible: false
        });
    }

    handleChangeStylistModalAgree = () => {
        this.setState({
            isChangeStylistModalVisible: false
        });
        let { barcodes, barcode } = this.state;
        barcodes.push(barcode);
    };

    render() {
        let { barcodes, key, custKey, filteredUsers, filteredCustomers, loading } = this.state;

        return (
            <div className="columns is-gapless">
                <div className="column is-1 is-hidden-mobile">
                    <section className="hero is-fullheight hero-stylist-pattern">
                        <div className="hero-body"></div>
                    </section>
                </div>

                <div className="column">
                    <div className={styles.wrapper}>
                        <Container maxWidth="sm" className={styles.container}>
                            <SearchBar
                                onChange={val => this.search(val)}
                                onRequestSearch={() => this.search(key)}
                                onCancelSearch={() => {
                                    this.setState({
                                        key: "",
                                        barcode: "",
                                        filteredUsers: [],
                                        stylist: null,
                                        barcodes: []
                                    });
                                }}
                                style={{
                                    margin: "0 auto",
                                    maxWidth: 800
                                }}
                                placeholder="Select Stylist"
                                value={key}
                            ></SearchBar>

                            {!loading && filteredUsers.length !== 0 && (
                                <List className={styles.listbox}>
                                    {filteredUsers.map((user, index) => (
                                        <ListItem className={styles.item} key={index} button>
                                            <ListItemText
                                                primary={`${user.first_name} ${user.last_name}\xa0\xa0\xa0\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0\xa0\xa0\xa0${user.id}`}
                                                onClick={() => this.selectUser(user)}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            )}

                            <SearchBar
                                onChange={val => this.searchCustomer(val)}
                                onRequestSearch={() => this.searchCustomer(custKey)}
                                onCancelSearch={() => {
                                    this.setState({
                                        custKey: "",
                                        barcode: "",
                                        filteredCustomers: [],
                                        customerSelected: null,
                                    });
                                }}
                                style={{
                                    margin: "15px auto",
                                    maxWidth: 800
                                }}
                                placeholder="Select Customer"
                                value={custKey}
                            ></SearchBar>

                            {!loading && filteredCustomers.length !== 0 && (
                                <List className={styles.listbox}>
                                    {filteredCustomers.map((user, index) => (
                                        <ListItem className={styles.item} key={index} button>
                                            <ListItemText
                                                primary={`${user.first_name} ${user.last_name}\xa0\xa0\xa0\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0\xa0\xa0\xa0${user.id}`}
                                                onClick={() => this.selectCustomer(user)}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            )}

                            <List>
                                {barcodes.map((code, index) => (
                                    <ListItem className={styles.item} key={index}>
                                        <ListItemText
                                            style={{ fontWeight: "bold" }}
                                            primary={
                                                <React.Fragment>
                                                    <span style={{ fontWeight: "bold", marginRight: 10 }}>
                                                        User:
                                                    </span>
                                                    <span style={{ marginRight: 5 }}>{code.first_name}</span>
                                                    <span style={{ marginRight: 20 }}>{code.last_name}</span>
                                                    <span>{code.id}</span>
                                                </React.Fragment>
                                            }
                                        />
                                        <ListItemSecondaryAction>
                                            <IconButton
                                                edge="end"
                                                aria-label="delete"
                                                onClick={() => {
                                                    this.removeBarCode(code);
                                                }}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                ))}
                            </List>

                            <div className={styles.buttonContainer}>
                                <Button
                                    variant="contained"
                                    className={styles.button}
                                    onClick={() => this.addClicked()}
                                >
                                    TO STYLIST
                                </Button>
                            </div>

                            {/** Show WarningModal */}
                            <WarningModal
                                open={this.state.isModalVisible}
                                contentText={`Are you sure to send these users to the stylist?`}
                                onDisagree={this.handleModalDisagree}
                                onAgree={this.handleModalAgree}
                            />
                            <WarningModal
                                open={this.state.isChangeStylistModalVisible}
                                contentText={`Are you sure to re-assign this user to another stylist?`}
                                onDisagree={this.handleChangeStylistModalDisagree}
                                onAgree={this.handleChangeStylistModalAgree}
                            />
                        </Container>
                    </div>
                </div>
            </div>
        );
    }
}

StylistAssignContainer.contextType = AppContext;

StylistAssignContainer.propTypes = {
    history: PropTypes.object
};

export default connect(mapStateToProps)(StylistAssignContainer);
